<template>
	<v-dialog v-model="dialog" max-width="300px" hide-overlay>
		<template v-slot:activator="{ on }">
			<v-btn color="#1A237E" class="text-lowercase" dark small v-on="on">delete trademark</v-btn>
		</template>
		<v-card v-if="!loading" class="text-md-center">
			<v-card-text class="pt-4 black--text">
				<span class="subtitle-2">
				Would you like to delete all models of the trademark <span class="accentColor">{{ this.brand.trademark }}</span>?
				</span>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="#1A237E" text
					class="text-capitalize" 
					@click="closeDialog">
					No
				</v-btn>
				<v-btn color="#1A237E" text
					class="text-capitalize"
					@click="deleteBrand"
					>Yes</v-btn>
			</v-card-actions>
		</v-card>
		<div v-else class="text-xs-center">
			<loader></loader>
		</div>
	</v-dialog>
</template>

<script>

	import Loader from '../../layouts/Loader.vue'

	export default {
		props: ['brand', 'gameId', 'round'],
		data () {
			return	{
				dialog: false
			}
		},
		computed: {
			loading () {
				return this.$store.getters.loading
			},
			channels () {
				return this.$store.getters.channels
			},
			spots () {
				return this.$store.getters.spots
			}
		},
		methods: {
			async deleteBrand () {
				try {
					//match = channels with the trademark
					const match = this.channels.filter(channel => {
						return channel.trademarks.find(tr => tr === this.brand.trademark)
					})			
					//change or delete channels with the deleted trademark
					for (let i = 0; i < match.length; i++) {
						const channel = match[i]
						const trademarks = channel.trademarks.filter(item => item !== this.brand.trademark)//trademarks without to delete one
						
						if (trademarks.length) {
							//change channel
							
							const newchannel = {
								company: channel.company,
								coverage: channel.coverage,
								id: channel.id,
								name: channel.name,
								numbers: channel.numbers,
								trademarks: trademarks,
								type: channel.type,					
							}
							await this.$store.dispatch('changeChannel', {
								gameId: this.gameId,
								round: this.round,
								channel: channel
							})
						}//if channel has no trademarks => delete channel 
						else {
							await this.$store.dispatch('deleteChannel', {
								channel: channel.id,
								gameId: this.gameId,
								round: this.round
							})
						}
					}
					//spots with the trademark => to delete
					const toDelete = this.spots.filter(item => item.trademark === this.brand.trademark)
					console.log(toDelete)
					if (toDelete.length) {
						for (let i = 0; i < toDelete.length; i++) {
							
							const spot = toDelete[i]

							await this.$store.dispatch('deleteSpot', {
								gameId: this.gameId,
								round: this.round,
								id: spot.id
							})
						}
					}
					//delete product
					const id = this.brand.id
					await this.$store.dispatch('deleteBrand', {
						id: id,
						gameId: this.gameId,
						round: this.round
					})
					this.closeDialog ()			
				}
				catch (error) {
					console.log(error.message)
					await this.$store.dispatch('setError', error.message)//throw error
				}
			},

			closeDialog () {
				//reset
				this.dialog = false
			}
		},
		components: {Loader}
	}
</script>
<style>
	.error{
		color: white
	}
</style>